export const MatchStatuses = [
        "player-1-defaulted-player-2-won",
        "player-2-defaulted-player-1-won",
        "cancelled",
        "retired",
        "postponed",
        "player-1-retired-player-2-won",
        "player-2-retired-player-1-won",
        "abandoned"
    ];